import React from 'react';
import {
  TableRow,
  TableCell,
  Typography,
  makeStyles
} from '@material-ui/core';

const CartTotal = ({ totalCartPrice, balance }) => {

  const useStyles = makeStyles((theme) => ({
    balance: {
      color: theme.palette.success.main
    },
    remaining: {
      color: theme.palette.error.main
    }
  }))

  const classes = useStyles()

  const balanceAfterPurchase = balance - totalCartPrice

  return (
    <React.Fragment>
      <TableRow>
        <TableCell rowSpan="3" />
        <TableCell colSpan="2"><Typography variant="h6">Total Price</Typography></TableCell>
        <TableCell align="center"><Typography variant="h5" className={classes.total}>${totalCartPrice.toFixed(2)}</Typography></TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan="2"><Typography variant="h6">Balance</Typography></TableCell>
        <TableCell align="center"><Typography variant="h5" className={classes.balance}>${balance.toFixed(2)}</Typography></TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan="2"><Typography variant="h6">Balance after purchase</Typography></TableCell>
        <TableCell align="center"><Typography variant="h5" className={classes.remaining}>${balanceAfterPurchase.toFixed(2)}</Typography></TableCell>
      </TableRow>
    </React.Fragment>
  )
}

export default CartTotal;